import React from 'react';
import { RecoilRoot } from 'recoil';
import CheckoutProvider from './providers/checkout';
import CustomerProvider from './providers/customer';

export const wrapRootElement = ({ element }) => (
  <RecoilRoot>
    <CheckoutProvider>
      <CustomerProvider>{element}</CustomerProvider>
    </CheckoutProvider>
  </RecoilRoot>
);
